import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFreeWorkoutPlans, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { ASSIGN_FREE_WORKOUT_PLAN_CREATE, FREE_WORKOUT_PLANS_GET, UNASSIGN_FREE_WORKOUT_PLAN_UPDATE } from '../new';

import { useEffectOnSuccess } from '.';

const useFreeWorkoutPlans = () => {
  const dispatch = useDispatch();
  const freePlans = useSelector(state => state.workoutPlans.freePlans);

  useEffect(() => {
    if (freePlans.status === StateStatus.NOT_INITIALIZED) {
      dispatch(getFreeWorkoutPlans());
    }
  }, [dispatch, freePlans.status]);

  useEffectOnSuccess([state => state.workoutPlans.assignFreeToUser, state => state.workoutPlans.unassignFreeFromUser], () => {
    dispatch(resetState(FREE_WORKOUT_PLANS_GET));
    dispatch(resetState(ASSIGN_FREE_WORKOUT_PLAN_CREATE));
    dispatch(resetState(UNASSIGN_FREE_WORKOUT_PLAN_UPDATE));
  });

  return freePlans;
};

export default useFreeWorkoutPlans;
